import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Fido2Module } from './module/fido/fido.module';
import { BackupcodeModule } from './module/backupcode/backupcode.module';
import { TotpModule } from './module/totp/totp.module';
import { FaceModule } from './module/face/face.module';
import { TouchidModule } from './module/touchid/touchid.module';
import { PatternModule } from './module/pattern/pattern.module';
import { PushModule } from './module/push/push.module';
import { SmsModule } from './module/sms/sms.module';
import { IvrModule } from './module/ivr/ivr.module';
import { EmailModule } from './module/email/email.module';
import { VerificationComponent } from './verification.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UtilComponentsModule } from './../../shared/util-components/util-components.module';

@NgModule({
  declarations: [
    VerificationComponent,
  ],
  imports: [
    CommonModule,
    Fido2Module,
    BackupcodeModule,
    TotpModule,
    FaceModule,
    TouchidModule,
    PatternModule,
    PushModule,
    SmsModule,
    IvrModule,
    EmailModule,
    TranslateModule,
    UtilComponentsModule,
  ],
  exports: [VerificationComponent],
  providers:[TranslateService]
})
export class VerificationModule { }
